import pageBuilder from '@blaze-cms/plugin-page-builder-fe';
import gtm from '@blaze-cms/plugin-gtm-fe';
import googleMaps from '@blaze-cms/plugin-google-maps-fe';
import previewFe from '@blaze-cms/plugin-preview-fe';
import authFe from '@blaze-cms/plugin-auth-fe';
import structuredDataFe from '@blaze-cms/plugin-structured-data-fe';
const plugins = new Map();
plugins.set(pageBuilder, {});
plugins.set(gtm, {});
plugins.set(googleMaps, {});
plugins.set(previewFe, {});
plugins.set(authFe, {});
plugins.set(structuredDataFe, {
  authenticatedBotHeaders: ['x-amzn-waf-googlebot']
});
const apollo = {
  uri: process.env.BLAZE_GRAPHQL_URI,
  loadEntitiesInBrowser: false
};
export default {
  plugins,
  apollo
};
//# sourceMappingURL=blaze.config.js.map